import { TextField } from '@mui/material';
import React from 'react';
import styles from './StringEditor.module.css';
import { useTranslation } from 'react-i18next';

const StringEditor = ({ option, setOption }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.stringEditorWrapper}>
      <TextField
        variant='outlined'
        placeholder={t('queryBuilder.queryParam.stringEditor', { name: option.displayName.toLowerCase() })}
        fullWidth
        size='small'
        InputProps={{
          className: styles.input,
          style: { fontFamily: 'var(--font-main)' }
        }}
        onChange={(e) => setOption({ ...option, value: `${option.name}=${e.target.value}` })}
      />
    </div>
  );
};

export default StringEditor;
